module.exports = "../dist/img/5.166b.jpeg";